/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Button_InjectInputs */

const en_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest Rewording`)
};

const de_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umformulierung vorschlagen`)
};

const fr_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggérer une reformulation`)
};

const es_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir reformulación`)
};

const it_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerisci riformulazione`)
};

const nl_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herformulering voorstellen`)
};

const pl_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproponuj przeformułowanie`)
};

const fi_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdota uudelleenmuotoilua`)
};

const da_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslå omformulering`)
};

const sv_keyword_optimizer_button_inject = /** @type {(inputs: Keyword_Optimizer_Button_InjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föreslå omformulering`)
};

/**
* | output |
* | --- |
* | "Suggest Rewording" |
*
* @param {Keyword_Optimizer_Button_InjectInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_inject = /** @type {((inputs?: Keyword_Optimizer_Button_InjectInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_InjectInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_inject(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_inject(inputs)
	if (locale === "es") return es_keyword_optimizer_button_inject(inputs)
	if (locale === "it") return it_keyword_optimizer_button_inject(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_inject(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_inject(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_inject(inputs)
	if (locale === "da") return da_keyword_optimizer_button_inject(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_inject(inputs)
	return en_keyword_optimizer_button_inject(inputs)
});